import form from '@/mixins/crud-form';
import utils from '@/utils';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'MARKET_SERVICE_CONFIG_TEST_GET',
        update: 'MARKET_SERVICE_CONFIG_TEST'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'user_mobile',
        default: '',
        label: this.$t('user_mobile'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "model": {
              value: _this.form.model.user_mobile,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "user_mobile", $$v);
              }
            }
          });
        }
      }, {
        prop: 'content_select',
        default: '',
        label: this.$t('content_select'),
        col: {
          span: 24
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "form_content_select",
              "custom": true,
              "stringify": true
            },
            "on": {
              "change": _this.onContentSelectChange
            },
            "model": {
              value: _this.form.model.data,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "data", $$v);
              }
            }
          });
        }
      }, {
        prop: 'content_edit',
        default: '',
        label: this.$t('content_edit'),
        col: {
          span: 24
        },
        render: function render() {
          return h("el-input", {
            "model": {
              value: _this.form.model.sms_model_content,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "sms_model_content", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: {
    /**
         * @description 加载需要的字典数据
         */
    loadDict: function loadDict() {
      this.loadDictOne({
        name: 'form_content_select',
        method: this.$api.SMS_MODEL_CONFIG_ALL,
        fields: 'id,sms_model_content',
        path: 'list',
        label: 'id',
        value: 'sms_model_content'
      });
    },
    onContentSelectChange: function onContentSelectChange(data) {
      this.modelSet('sms_model_content', data);
    }
  }
};